import { TRANSLATIONS_URL } from 'constants/ApiConstants';
import { TranslationOrigin } from 'constants/translationConstants';
import type { ApiError, MetaAction } from 'modules/global/generic.types';

import * as types from './actionTypes';
import type * as I18nTypes from './types';

export const switchLocale = (locale: string, meta: MetaAction = {}): I18nTypes.SwitchLocaleRequestAction => ({
  type: types.LOCALE_SWITCH,
  payload: locale,
  meta,
});

export const switchLocaleSuccess = (locale: string, meta: MetaAction = {}): I18nTypes.SwitchLocaleSuccessAction => ({
  type: types.LOCALE_SWITCH_SUCCESS,
  payload: locale,
  meta,
});

export const switchLocaleFailure = (error: ApiError, meta: MetaAction = {}): I18nTypes.SwitchLocaleFailureAction => ({
  type: types.LOCALE_SWITCH_FAILURE,
  payload: error,
  error: true,
  meta,
});

/** The worker reads the active locale off the store, so the action carries no payload. */
export const fetchAppTranslations = (meta: MetaAction = {}): I18nTypes.FetchAppTranslationsRequestAction => ({
  type: types.FETCH_APP_TRANSLATIONS_REQUEST,
  meta,
});

export const fetchTranslations = (
  { keys, languages, origin = TranslationOrigin.BO, ...params }: I18nTypes.FetchTranslationsPayload,
  meta: MetaAction = {}
): I18nTypes.FetchTranslationsRequestAction => ({
  type: types.FETCH_TRANSLATIONS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${process.env.REACT_APP_PUBLIC_URL_BASE}${TRANSLATIONS_URL}${origin}`,
      params: {
        keys: Array.isArray(keys) ? keys.join(',') : keys,
        languages: Array.isArray(languages) ? languages.join(',') : languages,
        ...params
      },
    },
    keys,
    origin,
    languages,
  },
  meta,
});

export const fetchTranslationsSuccess = (
  translations: I18nTypes.TranslationsByLocale,
  meta: MetaAction = {}
): I18nTypes.FetchTranslationsSuccessAction => ({
  type: types.FETCH_TRANSLATIONS_SUCCESS,
  payload: translations,
  meta
});

export const fetchTranslationsFailure = (
  error: ApiError,
  meta: MetaAction = {}
): I18nTypes.FetchTranslationsFailureAction => ({
  type: types.FETCH_TRANSLATIONS_FAILURE,
  payload: error,
  error: true,
  meta,
});
